import { HighlightStyle } from "@codemirror/language";
import { tags } from "@lezer/highlight";

// Documentation about tags: https://lezer.codemirror.net/docs/ref/#highlight.tags
// The schema has been copied from https://github.com/prometheus/promlens/blob/6c65228f99dfdf18d69a54f6d695c581f5d9c2e2/app/src/PromLens/QueryList/QueryView/ExpressionEditor/Theme.tsx#L170
export const promQLHighlighter = HighlightStyle.define([
	{ tag: tags.name, color: "#000" },
	{ tag: tags.number, color: "#09885a" },
	{ tag: tags.string, color: "#a31515" },
	{ tag: tags.keyword, color: "#008080" },
	{ tag: tags.function(tags.variableName), color: "#008080" },
	{ tag: tags.labelName, color: "#800000" },
	{ tag: tags.operator },
	{ tag: tags.modifier, color: "#008080" },
	{ tag: tags.paren },
	{ tag: tags.squareBracket },
	{ tag: tags.brace },
	{ tag: tags.invalid, color: "red" },
	{ tag: tags.comment, color: "#888", fontStyle: "italic" },
]);
